// extracted by mini-css-extract-plugin
export default {"container":"AuthProvider_container__6K73m"};